define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.EngagementsHistory = function () {
        this.applicationType = "EngagementsHistory";
        var logger = WebAgentLogger.getLogger(this.applicationType);
        var POLLING_TIME_IN_SEC = 20;

        var engagementHistoryApiResources = agentLEManager.getLEUrlResolverApiResourcesService(this.applicationType);
        var engagementHistorySearchResource;
        var searchResourceAdditionalUrl;

        if (engagementHistoryApiResources && engagementHistoryApiResources.Search && engagementHistoryApiResources.Search.url) {
            var fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(engagementHistoryApiResources.Search.url);
            var resourceDomainUrl = lpUtils.getSubDomain(fullResourceUrl);
            searchResourceAdditionalUrl = fullResourceUrl.substring(resourceDomainUrl.length);
            engagementHistorySearchResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, postmessagePath: "/postmessage", serviceName: this.applicationType});
        }

        /**
         * Search for engagements by polling of direct call - depends the request object
         * @param {object} reqObj
         * @param {boolean=} ignorePolling when true - polling will not be affected if was started before
         */
        this.searchEngagements = function(reqObj, ignorePolling) {
            reqObj.callingFunction = 'searchEngagements';
            reqObj.method = 'POST';
            reqObj.additionalUrl = searchResourceAdditionalUrl;
            reqObj.timeout = 20000;
            if (reqObj.pollingCallback) {
                reqObj.pollingTimeout = lpTag.WebAgent.logicController.getPollingRefreshRateFromSiteSettings("le.agent.webHistory.refreshRate", 1000 * POLLING_TIME_IN_SEC);
                engagementHistorySearchResource.startPolling(reqObj);
            } else {
                if(!ignorePolling) {
                    engagementHistorySearchResource.stopPolling();
                }
                engagementHistorySearchResource.sendRequest(reqObj);
            }
        };

        this.stopPolling = function () {
            engagementHistorySearchResource.stopPolling();
        };
    };

    return lpTag.EngagementsHistory;

});
